
import {throwError as observableThrowError,  Subject, Observable } from 'rxjs';

import {mergeMap, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
@Injectable()
export class LeiService {

  private registerPath : String = '/register';
  private codePath : String = '/code';
  private verifyPath : String = '/verify';
  private serverPath : String = '/research/open/unbundling';
  private tokenPath : string = '/token';
  private token : string;

  constructor(private http: HttpClient) {
  }

  private serverError(err: any) {
    if(err instanceof Response) {
      return observableThrowError(err.json()|| 'backend server error1');
      // if you're using lite-server, use the following line
      // instead of the line above:
      //return Observable.throw(err.text() || 'backend server error');
    }
    return observableThrowError(err || 'backend server error2');
  }

  private absoluteUrl(path) : string  {
    let isLocalhost = window.location.hostname == 'localhost';
    let host = isLocalhost ? 'http://localhost:8080' : '';
    return host + this.serverPath + path;
  }

  private getToken() : Observable<string> {

    if (!!this.token) {
      return new Observable( (observer) => {
        observer.next(this.token);
        observer.complete();
      });
    } else {
      return this.http.post(this.absoluteUrl(this.tokenPath), null, {observe: 'response'}).pipe(
        map(res => {
          return res.headers.get('X-Error-Code')
        }),
        catchError(this.serverError),);
    }

  }

  private submitRequest(formData, path) : Observable<string> {

        let headersObj: HttpHeaders = new HttpHeaders();
        headersObj = headersObj.append('Content-Type', 'application/json');

        let data = JSON.stringify(formData);
        let url = this.absoluteUrl(path);

        return this.http.post<string>(url, data, {headers: headersObj}).pipe(
          map(res => res),
          catchError(this.serverError),);

  }

  public submitLeiData(formData): Observable<string> {
    return this.submitRequest(formData, this.registerPath);
  }

  public submitCodeData(formData): Observable<string> {
    return this.submitRequest(formData, this.codePath);
  }

  public submitVerifyData(formData): Observable<string> {
    return this.submitRequest(formData, this.verifyPath);
  }

}
